import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { Tag } from '@spotahome/ui-library';

import './HomecardLabel.scss';

const CHECKED = 'checked';
const OFFER = 'offer';
const PERMANENT_CONTRACT = 'permanentContract';
const BEST_CHOICE = 'bestChoice';

const chipsRenders = {
  [CHECKED]: () => (
    <Tag label={trans('homecard.label.checked').toUpperCase()} isDarkMode />
  ),
  [OFFER]: () => null,
  [PERMANENT_CONTRACT]: () => null,
  [BEST_CHOICE]: () => null
};

const renderChip = labelToRender => chipsRenders[labelToRender]();

const HomeCardLabels = ({ checked }) => checked && renderChip(CHECKED);

HomeCardLabels.propTypes = {
  checked: PropTypes.bool.isRequired
};

export const generateHomeCardLabels =
  ({ checked }) =>
  () =>
    checked ? <HomeCardLabels checked={checked} /> : null;

export default generateHomeCardLabels;
